import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { Box, Button, Typography } from "@mui/material";

import ProjectCategoryOverlay from "./projects/ProjectCategoryOverlay";

import { LanguageContext } from "../../contexts/Language";
import { t } from "../../contexts/Language/reducer";

import { MEDIA_QUERY_MAX_WIDTH } from "../../util/Constants";
import { capitalizeWord } from "../../util/Functions";
import useMediaQuery from "../../util/hooks/useMediaQuery";

export const StylesSmall = { typography: { fontSize: "16px" } };
export const StylesLarge = { typography: { fontSize: "30px" } };

interface ScreenOverlayProps {
  onItemSelect: () => void;
  onSubItemSelect: () => void;
  subOverlay: string | null;
  setSubOverlay: (overlay: string | null) => void;
}

const ScreenOverlay: React.FC<ScreenOverlayProps> = (props) => {
  const { onItemSelect, onSubItemSelect, subOverlay, setSubOverlay } = props;

  const navigate = useNavigate();

  const goTo = (path: string): void => {
    onItemSelect();
    navigate(`/${path}`);
  };

  const [languageState, languageDispatch] = useContext(LanguageContext);

  const MAX_WIDTH_QUERY = `(max-width: ${MEDIA_QUERY_MAX_WIDTH}px)`;
  const matches = useMediaQuery(MAX_WIDTH_QUERY);

  const goToSubOverlay = (newSubOverlay: string): void => {
    setSubOverlay(newSubOverlay);
  };

  const resetSubOverlaySelection = () => setSubOverlay(null);

  const styles = matches ? StylesSmall : StylesLarge;

  if (subOverlay === "projects") {
    return (
      <ProjectCategoryOverlay
        onItemSelect={onSubItemSelect}
        onBack={resetSubOverlaySelection}
        styles={styles}
        languageState={languageState}
      />
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Button variant="outlined" onClick={() => goTo("")}>
        <Typography sx={{ ...styles.typography }}>
          {capitalizeWord(t("homepage", languageState))}{" "}
        </Typography>
      </Button>
      <Button variant="outlined" onClick={() => goToSubOverlay("projects")}>
        <Typography sx={{ ...styles.typography }}>
          {capitalizeWord(t("projects", languageState))}
        </Typography>
      </Button>
      <Button variant="outlined" onClick={() => goTo("portfolio")}>
        <Typography sx={{ ...styles.typography }}>
          {capitalizeWord(t("portfolio", languageState))}
        </Typography>
      </Button>
      <Button variant="outlined" onClick={() => goTo("about-me")}>
        <Typography sx={{ ...styles.typography }}>
          {capitalizeWord(t("about me", languageState))}
        </Typography>
      </Button>
    </Box>
  );
};

export default ScreenOverlay;
